'use client';

import { useEffect } from 'react';
import { install } from '@crehana/devtools';

// biome-ignore lint/complexity/noBannedTypes: legacy type usage

export var Devtools = function Devtools() {
  useEffect(function () {
    install();
  }, []);
  return null;
};